import { BuilderElements } from "@/types/elements";

export function appendRootElement(builderElements: BuilderElements) {
  const rootElementBuilderElements: BuilderElements = {
    root: {
      uiIcon: false,
      name: "Root",
      className: false,
      slug: "root",
      category: "misc",
      badge: false,
      htmlTag: {
        default: "doesnt matter",
        options: [],
        pathToControl: false
      },
      template: "doesnt matter",
      attributes: false,
      cssTemplate: "",
      defaultCss: "",
      defaultProperties: false,
      defaultChildren: false,
      controls: {
        contentSections: [],
        designSections: [],
        settingsSections: []
      },
      dependencies: false,
      actions: false,
      nestingRule: {
        type: "root"
      },
      spacingBars: false,
      dynamicPropertyPaths: false,
      settings: false,
      addPanelRules: {
        alwaysHide: true
      },
      experimental: false,
      availableIn: ["oxygen", "breakdance"],
      order: 0,
      additionalClasses: false,
      projectManagement: false,
      propertyPathsToWhitelistInFlatProps: false,
      propertyPathsToSsrElementWhenValueChanges: false
    }
  };

  return { ...builderElements, ...rootElementBuilderElements };
}
